module.exports = "\n\n<canvas-component></canvas-component>\n\n"


//////////////////
// WEBPACK FOOTER
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main